<div>
  Wollen Sie das Gerät ({{data.deviceDescription}}) wirklich löschen?
</div>
<div mat-dialog-actions class="flex-end">
  <button (click)="deleteDevice()" color="warn" mat-raised-button>Löschen</button>
  <button [mat-dialog-close]="" color="success" mat-raised-button>Abbrechen</button>
</div>
